import { writable } from "svelte/store";

export type NotificationMessage = {
    level: "info" | "warn" | "error";
    id?: string;
    title: string;
    duration?: number;
    dismissible?: boolean;
    onDismiss?: () => void;
} & ({
    type: "message";
    message: string;
} | {
    type: "custom";
    component: any;
    props?: Record<string, any>;
});


export const notificationColors = {
    info: "#007bff",
    warn: "#ffc107",
    error: "#dc3545",
};

export const notifications = writable<NotificationMessage[]>([]);

let currentId = 0;
export function notify(message: NotificationMessage): string {
    const msg = { ...message, id: message.id ?? "" + currentId++ };

    const duration = message.duration ?? message.dismissible ? 0 : 5000;
    if (duration > 0) {
        setTimeout(() => {
            notifications.update((messages) => messages.filter((m) => m !== msg));
        }, duration);
    }

    notifications.update((messages) => {
        if (messages.find(m => m.id === msg.id)) return messages;
        return [...messages, msg];
    });

    return msg.id;
}

export function dismiss(id: string) {
    notifications.update((messages) => {
        messages.find(m => m.id === id)?.onDismiss?.();
        return messages.filter((m) => m.id !== id);
    });
}